export default __webpack_public_path__ + "static/media/Blog1.79541c27.png";